import { setStatus } from './chatFilterSetters';
const updateStatusFilter = (filters, filterValue) => {
  return setStatus(filterValue, filters);
};
export default updateStatusFilter;